module.exports = __webpack_public_path__ + "dcb9bc1ead20053aa4a9de47caf284bc.MP3";